import React, { useState } from 'react';
import {
  Button
} from '@material-ui/core';
import CopyStoreList from './CopyStoreListing';


const CopyStoreListings: React.FC<ICopyStoreListingsProps> = ({
  allStoreProducts,
  classes
}) => {
  const [openModal, setOpenModal] = useState(false);

  return (
    <>
      <Button
        variant="outlined"
        color="primary"
        className={classes}
        title="Click here to add a standard/common SKU"
        onClick={() => setOpenModal(true)}
      >
        Copy My Listings from My Store
      </Button>
      <CopyStoreList
        open={openModal}
        onClose={() => setOpenModal(false)}
        allStoreProducts={allStoreProducts}
      />
    </>
  );
};

export default CopyStoreListings;
